const SuccessIconWithBackground = () => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28.4648" cy="28" r="28" fill="#41D195" fillOpacity="0.12" />
      <path
        d="M27.9642 14.666C20.6175 14.666 14.6309 20.6527 14.6309 27.9993C14.6309 35.346 20.6175 41.3327 27.9642 41.3327C35.3109 41.3327 41.2975 35.346 41.2975 27.9993C41.2975 20.6527 35.3109 14.666 27.9642 14.666ZM34.3375 24.9327L26.7775 32.4927C26.5909 32.6793 26.3375 32.786 26.0709 32.786C25.8042 32.786 25.5509 32.6793 25.3642 32.4927L21.5909 28.7193C21.2042 28.3327 21.2042 27.6927 21.5909 27.306C21.9775 26.9193 22.6175 26.9193 23.0042 27.306L26.0709 30.3727L32.9242 23.5193C33.3109 23.1327 33.9509 23.1327 34.3375 23.5193C34.7242 23.906 34.7242 24.5327 34.3375 24.9327Z"
        fill="#41D195"
      />
    </svg>
  );
};
export default SuccessIconWithBackground;
